import React from "react";
import { Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LEGAL_PATHS } from "../../../../Components/Auth/Legal/legalRules";

// The old /Termsandconditions route: the Terms of Service have their own page now, in
// French (/conditions) and in English (/terms). This sends old links and bookmarks to
// the one in the reader's language.
const Termsandconditions = () => {
  const { i18n } = useTranslation();
  const lang = i18n.resolvedLanguage === "fr" ? "fr" : "en";
  return <Navigate to={LEGAL_PATHS.terms[lang]} replace />;
};

export default Termsandconditions;
